/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import {
  UserTokenInfo,
  UserSignInOAuthUrl,
  UserSignOutOAuthUrl,
  UserPermissionList,
  UserDepartRoleList
} from './types';

class User extends Immerable {
  public userIsLogin: boolean;

  public userAuthCheck: boolean;

  public userOAuthProcess?: boolean;

  public userTokenInfo: UserTokenInfo;

  public userSignInOAuthUrl: UserSignInOAuthUrl;

  public userSignOutOAuthUrl: UserSignOutOAuthUrl;

  public userPermissionList: UserPermissionList;

  public userRoleList: UserDepartRoleList;

  public constructor() {
    super();
    this.userIsLogin = false;
    this.userAuthCheck = false;
    this.userOAuthProcess = undefined;
    this.userTokenInfo = {
      token_type: 'Bearer',
      token: '',
      user: {
        id: 0,
        name: '',
        email: '',
        is_admin: false
      }
    };
    this.userSignInOAuthUrl = {
      link: ''
    };
    this.userSignOutOAuthUrl = {
      link: ''
    };
    this.userPermissionList = {
      list: []
    };
    this.userRoleList = {
      list: []
    };
  }

  public initialize(): void {
    this.userIsLogin = false;
    this.userAuthCheck = false;
    this.userOAuthProcess = undefined;
    this.userTokenInfo = {
      token_type: 'Bearer',
      token: '',
      user: {
        id: 0,
        name: '',
        email: '',
        is_admin: false
      }
    };
    this.userSignInOAuthUrl = {
      link: ''
    };
    this.userSignOutOAuthUrl = {
      link: ''
    };
    this.userPermissionList = {
      list: []
    };
    this.userRoleList = {
      list: []
    };
  }

  public initializeApplication(): void {
    this.userIsLogin = false;
    this.userOAuthProcess = undefined;
    this.userTokenInfo = {
      token_type: 'Bearer',
      token: '',
      user: {
        id: 0,
        name: '',
        email: '',
        is_admin: false
      }
    };
    this.userSignInOAuthUrl = {
      link: ''
    };
    this.userSignOutOAuthUrl = {
      link: ''
    };
    this.userPermissionList = {
      list: []
    };
    this.userRoleList = {
      list: []
    };
  }

  public updateUserLoginState(newUserLoginState: boolean): void {
    this.userIsLogin = newUserLoginState;
  }

  public updateUserAuthCheck(newUserAuthCheck: boolean): void {
    this.userAuthCheck = newUserAuthCheck;
  }

  public updateUserOAuthProcess(newUserOAuthProcessState: boolean): void {
    this.userOAuthProcess = newUserOAuthProcessState;
  }

  public updateUserTokenInfo(newUserTokenInfo: UserTokenInfo): void {
    this.userTokenInfo = newUserTokenInfo;
  }

  public updateUserSignInOAuthUrl(newUserSignInOAuthUrl: UserSignInOAuthUrl): void {
    this.userSignInOAuthUrl = newUserSignInOAuthUrl;
  }

  public updateUserSignOutOAuthUrl(newUserSignOutOAuthUrl: UserSignOutOAuthUrl): void {
    this.userSignOutOAuthUrl = newUserSignOutOAuthUrl;
  }

  public updateUserPermissionList(newUserPermissionList: UserPermissionList): void {
    this.userPermissionList = newUserPermissionList;
  }

  public updateUserRoleList(newUserRoleList: UserDepartRoleList): void {
    this.userRoleList = newUserRoleList;
  }
}

export default User;
